import styled from 'styled-components';
import { rem } from 'polished';
import { LinkButton } from 'baseline-ui/button';

const ForgotPasswordLink = styled(LinkButton)`
    margin-right: ${rem(-10)};
`;

export default ForgotPasswordLink;
